var _linearGradient, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTest2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-1-0",
    gradientUnits: "userSpaceOnUse",
    x1: 251.882,
    y1: 78.426,
    x2: 251.882,
    y2: 421.573,
    gradientTransform: "matrix(1.277385, 0, 0, 1.277385, -71.748085, -69.347404)",
    xlinkHref: "#gradient-1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(237, 99, 209)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(237, 37, 123)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 247.596 30.835 C 374.804 30.835 478.297 123.978 478.297 238.465 C 478.297 278.492 465.629 317.259 441.629 350.771 C 446.176 401.04 458.355 438.359 476.042 456.038 C 478.381 458.376 478.964 461.952 477.488 464.906 C 476.172 467.543 473.49 469.166 470.604 469.166 C 470.253 469.166 469.89 469.143 469.529 469.088 C 466.414 468.651 394.066 458.231 341.744 428.042 C 312.023 440.029 280.37 446.095 247.596 446.095 C 171.774 446.095 104.378 413.005 62.301 362.029 C 101.125 390.253 155.629 407.809 215.986 407.809 C 333.869 407.809 429.432 340.836 429.432 258.221 C 429.432 175.606 333.869 108.633 215.986 108.633 C 129.679 108.633 55.337 144.532 21.702 196.186 C 43.46 101.902 136.48 30.835 247.596 30.835 Z",
    style: {
      strokeWidth: 0,
      fill: "url(#gradient-1-0)"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 181.376968, 147.496368)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 181.376968, 147.496368)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 181.376968, 147.496368)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 181.376968, 147.496368)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 181.376968, 147.496368)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 181.376968, 147.496368)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 181.376968, 147.496368)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 181.376968, 147.496368)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 181.376968, 147.496368)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 181.376968, 147.496368)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 181.376968, 147.496368)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 181.376968, 147.496368)"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 181.376968, 147.496368)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 181.376968, 147.496368)"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 181.376968, 147.496368)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "rgb(237, 99, 209)"
    },
    cx: 71.27,
    cy: 173.504,
    rx: 12.078,
    ry: 12.078
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "rgb(237, 99, 209)"
    },
    cx: 104.833,
    cy: 157.594,
    rx: 16.838,
    ry: 16.838
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "rgb(237, 99, 209)"
    },
    cx: 149.518,
    cy: 144.217,
    rx: 20.645,
    ry: 20.645
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "rgb(237, 99, 209)"
    },
    cx: 46.883,
    cy: 189.923,
    rx: 9.058,
    ry: 9.058
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest2);
export default __webpack_public_path__ + "static/media/test2.4516c3981e57a8eb3615bb6dbeb2f270.svg";
export { ForwardRef as ReactComponent };